<template>
    <v-row no-gutters>
        <v-col cols="3">
            <v-card-subtitle>썸네일</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text class="ml-4">
                <v-img v-if="value.thumb" :src="value.thumb" contain max-width="180" max-height="180"></v-img>
                <v-responsive v-else width="180" height="180">
                    <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                        <v-icon>mdi-image</v-icon>
                    </v-row>
                </v-responsive>
            </v-card-text>
        </v-col>
        <v-col cols="9">
            <v-card-subtitle>기본정보</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
                <v-row no-gutters class="ma-n2">
                    <v-col class="pa-4" cols="8"><v-text-field v-model="value.name" label="상품권명" readonly /></v-col>
                    <v-col class="pa-4" cols="4"><v-text-field v-model="value.platform" label="제공업체" readonly /></v-col>
                    <v-col class="pa-4" cols="3"><v-text-field v-model="value.faceamt" label="권종" readonly /></v-col>
                    <v-col class="pa-4" cols="3"><v-text-field v-model="value.cpamtRate" label="API 할인율" readonly /></v-col>
                    <v-col class="pa-4" cols="3"><v-text-field v-model="value.cpamt" label="API 가격" readonly /></v-col>
                    <v-col class="pa-4 pl-6" cols="3"><v-switch v-model="value.isApi" label="API 여부" readonly /></v-col>
                </v-row>
            </v-card-text>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) }
    },
};
</script>

<style>
</style>